import { selectedAdminTenant } from "./tenant-context";

export const SESSION_EXPIRED_EVENT = "fmc:session-expired";

const ACTIVE_SESSION_KEY = "fmc.activeSession";
const PUBLIC_PATHS = new Set([
  "/login",
  "/admin/login",
  "/account-setup",
  "/destination-verification",
  "/invitation-verification",
]);

export type SessionExpiryTarget = "admin" | "client";

export interface SessionExpiredDetail {
  target: SessionExpiryTarget;
}

export function markSessionActive(): void {
  window.sessionStorage.setItem(ACTIVE_SESSION_KEY, "true");
}

export function clearSessionActive(): void {
  window.sessionStorage.removeItem(ACTIVE_SESSION_KEY);
}

export function notifySessionExpired(): void {
  if (PUBLIC_PATHS.has(window.location.pathname)) return;
  if (window.sessionStorage.getItem(ACTIVE_SESSION_KEY) !== "true") return;

  const target: SessionExpiryTarget =
    window.location.pathname.startsWith("/admin") || selectedAdminTenant() ? "admin" : "client";

  clearSessionActive();
  window.dispatchEvent(
    new CustomEvent<SessionExpiredDetail>(SESSION_EXPIRED_EVENT, {
      detail: { target },
    }),
  );
}
